import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { publishIcon, republishIcon } from "@/lib/Images";

export const PublishConfirmModal = ({
  open,
  onClose,
  onPublish,
  isRepublish,
}) => {
  const title = isRepublish
    ? "Publish Latest Changes?"
    : "Publish this experience?";

  const description = isRepublish
    ? "You’re about to publish changes to an experience that is already live for users. Once published, the latest changes will immediately reflect on the user end."
    : "You’re about to make this experience live for users in the selected campaign. Once published, users will be able to access and interact with this experience.";

  const helperText = isRepublish
    ? "Make sure you have reviewed the updated content, interactions and flow before proceeding."
    : "Please review your content, interactions, and flow before proceeding.";

  const cancelText = isRepublish ? "Back" : "Cancel";
  const publishText = isRepublish ? "Publish Changes" : "Publish";

  const modalImage = isRepublish ? republishIcon : publishIcon;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="
          w-[calc(100vw-32px)]
          max-w-[720px]
          rounded-lg
          border
          border-brand-11
          bg-brand-19
          px-6
          py-10
          text-center
          text-neutral-100
          shadow-2xl
          sm:px-10
          sm:py-12
        "
      >
        <DialogHeader className="text-center">
          <div className="mx-auto mb-5 flex items-center justify-center">
            <img
              src={modalImage}
              className={isRepublish ? "h-24 w-24" : "h-52 w-68"}
              alt="Publish"
            />
          </div>

          <DialogTitle className="text-center text-2xl font-bold text-[#67D8FF]">
            {title}
          </DialogTitle>

          <DialogDescription className="mx-auto mt-5 max-w-xl text-center text-sm font-semibold leading-relaxed text-neutral-100">
            {description}
          </DialogDescription>

          <p className="mx-auto mt-5 max-w-xl text-sm text-center font-semibold text-[#67D8FF]">
            {helperText}
          </p>
        </DialogHeader>

        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            className="h-10 min-w-[110px] border-[#607A9B] bg-[#223957] px-8 font-bold text-neutral-100 hover:bg-[#2B466B] hover:text-neutral-100"
          >
            {cancelText}
          </Button>

          <Button
            type="button"
            onClick={onPublish}
            className="h-10 min-w-[140px] bg-brand-21 px-8 font-bold text-neutral-100 hover:bg-brand-22"
          >
            {publishText}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

// import { Check, Copy, Rocket } from "lucide-react";
// import {
//   Dialog,
//   DialogContent,
//   DialogDescription,
//   DialogHeader,
//   DialogTitle,
// } from "@/components/ui/dialog";
// import { Button } from "@/components/ui/button";
// import { publishIcon } from "@/lib/Images";
// export const PublishConfirmModal = ({ open, onClose, onPublish }) => {
//   return (
//     <Dialog open={open} onOpenChange={onClose}>
//       <DialogContent
//         className="
//           w-[calc(100vw-32px)]
//           max-w-[720px]
//           rounded-lg
//           border
//          border-brand-11
//           bg-brand-19
//           px-6
//           py-10
//           text-center
//           text-neutral-100
//           shadow-2xl
//           sm:px-10
//           sm:py-12
//         "
//       >
//         <DialogHeader className="text-center">
//           <div className="mx-auto mb-5 flex  items-center justify-center">
//             <img src={publishIcon} className="h-52 w-68" alt="Published" />
//             {/* <div className="relative flex h-20 w-20 items-center justify-center rounded-full bg-[#223957]">
//               <img src={publishIcon} className="h-4 w-4" alt="Published" />
//               <Rocket className="h-12 w-12 text-neutral-100" />
//               <span className="absolute bottom-2 right-2 flex h-6 w-6 items-center justify-center rounded-full bg-[#1E8DFF]">
//                 <Check className="h-4 w-4 text-neutral-100" />
//               </span>
//             </div> */}
//           </div>

//           <DialogTitle className="text-center text-2xl font-bold text-[#67D8FF]">
//             Publish this experience?
//           </DialogTitle>

//           <DialogDescription className="mx-auto mt-5 max-w-xl text-center text-sm font-semibold leading-relaxed text-neutral-100">
//             You’re about to make this experience live for users in the selected
//             campaign. Once published, users will be able to access and interact
//             with this experience. Any changes made after publishing will require
//             a new version to go live.
//           </DialogDescription>

//           <p className="mx-auto mt-5 max-w-xl text-sm font-semibold text-[#67D8FF]">
//             Please review your content, interactions, and flow before
//             proceeding.
//           </p>
//         </DialogHeader>

//         <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
//           <Button
//             type="button"
//             variant="outline"
//             onClick={onClose}
//             className="h-10 min-w-[110px] border-[#607A9B] bg-[#223957] px-8 font-bold text-neutral-100 hover:bg-[#2B466B] hover:text-neutral-100"
//           >
//             Cancel
//           </Button>

//           <Button
//             type="button"
//             onClick={onPublish}
//             className="h-10 min-w-[110px] bg-brand-21 px-8 font-bold text-neutral-100 hover:bg-brand-22"
//           >
//             Publish
//           </Button>
//         </div>
//       </DialogContent>
//     </Dialog>
//   );
// };
